import React from 'react';
// import "./format2.css"

const Format2 = ({ modifyForm  }) => {
  

  return (
    <>
    <style>
      {`   .__invTemplate2 .__mainTab_reps {
  width: 100%;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.__invTemplate2 .__inlineTables {
  width: 100%;
  border-collapse: collapse;
}

.__invTemplate2 .__inlineTables p {
  font-size: 10px;
  font-weight: 400;
  margin: 0px;
  line-height: 17px;
}

.__invTemplate2 .__vehTable {
  width: 100%;
  border-collapse: collapse;
}

.__invTemplate2 .__vehTable th,
.__invTemplate2 .__vehTable td {
  font-size: 9.5px;
  border: 1px solid #000;
  padding: 2px 1px;
}

.__invTemplate2 .__vehTable th {
  font-weight: 500;
}

.__invTemplate2 .__vehTable td {
  font-weight: 400;
}

.__invTemplate2 .__vehTable th:nth-child(1),
.__invTemplate2 .__vehTable td:nth-child(1) {
  border-left: none;
}

.__invTemplate2 .__vehTable th:last-child,
.__invTemplate2 .__vehTable td:last-child {
  border-right: none;
}

.__invTemplate2 .__vehTable td p {
  margin: 0;
  min-height: 10px;
}

.__invTemplate2 .__tfooterTab {
  width: 100%;
  min-height: 65px;
  border-collapse: collapse;
}

.__invTemplate2 .__tfooterTab td {
  font-size: 10px;
  vertical-align: bottom;
}

.__invTemplate2 .__tfooterTab td p {
  margin: 0px;
  line-height: 20px;
}

.sheet.padding-2mm_inv2 {
  padding: 2mm;
  background: white;
  page-break-after: always;
}

.sheet.padding-2mm_inv2:last-child {
  page-break-after: auto;
}

.sheet-content.__invTemplate2 {
  transform-origin: top left;
  transition: transform 0.2s ease;
  width: 210mm;
  margin: 0 auto;
}

@media (max-width: 319px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 320px) and (max-width: 339px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 340px) and (max-width: 359px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 360px) and (max-width: 379px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(22% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 380px) and (max-width: 399px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(24% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 400px) and (max-width: 419px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(26% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 420px) and (max-width: 439px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(26% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 440px) and (max-width: 459px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(28% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 460px) and (max-width: 479px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(28.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 480px) and (max-width: 499px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 500px) and (max-width: 519px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 520px) and (max-width: 539px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 540px) and (max-width: 559px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(33.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 560px) and (max-width: 579px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(35% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 580px) and (max-width: 599px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(36% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 600px) and (max-width: 629px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(37.5% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 630px) and (max-width: 669px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(38.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 670px) and (max-width: 699px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(42% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 700px) and (max-width: 739px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(44% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 740px) and (max-width: 769px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(46% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 770px) and (max-width: 799px) {
  .sheet-content.__invTemplate2 {
    transform: scale(calc(48% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (max-width: 767px) {
  .sheet-content.__invTemplate2 {
    margin: 0 auto;
  }
}

@media print {
  .sheet-content.__invTemplate2 {
    transform: scale(1) !important;
    width: 210mm;
  }

  .sheet.padding-2mm_inv2 {
    padding: 2mm;
  }

  @page {
    margin: 0px;
    size: A4 portrait;
  }
}
`}
    </style>

    <div className="sheet-content __invTemplate2">
  <section className="sheet padding-2mm_inv2">
    <div id="printableArea221">
      <table className="__mainTab_reps" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td>
              <table style={{ width: '100%', borderBottom: '1px solid #000' }}>
                <thead>
                  <tr>
                    <th textAlign="center" style={{ fontSize: '14px', padding: '2px', fontWeight: '600',textAlign:"center" }}>
                      {"VIMLA ENTERPRISES"}
                    </th>
                  </tr>
                </thead>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td align="center" style={{ padding: '0px' }}>
                      <p style={{ borderBottom: '1px solid #000', fontWeight: '500' }}>
                        {"PLOT NO. 259, P K V SOCIETY, KATOL ROAD BY PASS, DHABA NAGPUR - 440023"}
                      </p>
                      <p style={{ fontWeight: '500' }}>{"EMAIL ID:- viment.gwalior@gmail.com"}</p>
                      <p style={{ fontWeight: '500' }}>{ "MADHYA PRADESH"}</p>
                      <p style={{ fontWeight: '500' }}>{"TAX INVOICE"}</p>
                      <p style={{ fontWeight: '500' }}>{ "GSTIN: 27AALCC9434G1ZD"}</p>
                      <p style={{ minHeight: '16px' }}>{ ""}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td style={{ width: '30%' }}>
                      <p style={{ fontWeight: '500' }}>Company : { "PARLE BISCUITS PVT LTD"}</p>
                    </td>

                    <td style={{ width: '16%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>
                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>

                    <td style={{ width: '15%' }}>
                      <p style={{ fontWeight: '500' }}>BILL NO: { "HFIPL/2024-25/01"}</p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: '30%' }}>
                      <p style={{ fontWeight: '500' }}>Receiving State : </p>
                    </td>

                    <td style={{ width: '16%', border: '1px solid #000' }}>
                      <p style={{ fontWeight: '500' }}>Maharashtra</p>
                    </td>

                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>

                    <td style={{ width: '15%' }}>
                      <p style={{ fontWeight: '500' }}>BILL DATE: { "02.06.2025"}</p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: '30%' }}>
                      <p style={{ fontWeight: '500' }}>RECEIVING STATE GST NO : </p>
                    </td>

                    <td style={{ width: '16%', border: '1px solid #000' }}>
                      <p style={{ fontWeight: '500' }}>27AAACH3628L1ZG</p>
                    </td>

                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500', textAlign: 'center' }}>FREIGHT BILL</p>
                    </td>

                    <td style={{ width: '15%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: '30%' }}>
                      <p style={{ fontWeight: '500' }}>Vendor Code : 6000098</p>
                    </td>

                    <td style={{ width: '16%', border: '1px solid #000' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>

                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500', textAlign: 'center' }}></p>
                    </td>

                    <td style={{ width: '15%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
                <td style={{ paddingTop: '15px' }}>
                  <table className="__vehTable">
                    <thead>
                      <tr>
                        <th align="center" style={{ width: '3%', textAlign: 'center' }}>S.NO</th>
                        <th style={{ width: '3%' , textAlign: 'center'  }}>{`DESPATCH DATE`}</th>
                        <th style={{ width: '3%' , textAlign: 'center'  }}>FROM CODE</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>FROM NAME</th>
                        <th style={{ width: '3%', textAlign: 'center'  }}>TO CODE</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>TO NAME</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>{`Po Number`}</th>
                        <th style={{ width: '3%', textAlign: 'center' }}>STO Number</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>GAN Number</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>Received QTY in GAN</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>Kot</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>Vehicle Type</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>Freight</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>1</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>2</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>1,277.450</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>3</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>4</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>5</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>6</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>7</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C055</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>MB Foods, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vinayak Agencies, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Sing Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ textAlign: 'center' }}>
                          <p>8</p>
                        </td>
                        <td>
                          <p>5/25/2025</p>
                        </td>
                        <td>
                          <p>C166</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>Vardhman Bakers, Indore</p>
                        </td>
                        <td>
                          <p>B099</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>KM Enterprises, Mumbai</p>
                        </td>
                        <td align="right">
                          <p>4303779793</p>
                        </td>
                        <td>
                          <p></p>
                        </td>
                        <td>
                          <p>5000440245</p>
                        </td>
                        <td align="right">
                          <p>1,304.000</p>
                        </td>
                        <td align="right">
                          <p>2,220.900</p>
                        </td>
                        <td>
                          <p style={{ whiteSpace: 'nowrap' }}>32 Ft Cont Multy Axl</p>
                        </td>
                        <td align="right">
                          <p>35,800.00</p>
                        </td>
                      </tr>
                    </tbody>

                    <tfoot>
                      <tr>
                        <td align="left" colSpan="9"></td>
                        <td align="center" colSpan="3">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>TOTAL</p>
                        </td>
                        <td align="right" colSpan="1">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>213400</p>
                        </td>
                      </tr>

                      <tr>
                        <td align="left" colSpan="9"></td>
                        <td align="center" colSpan="3">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>IGST 12%</p>
                        </td>
                        <td align="right" colSpan="1">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>25608</p>
                        </td>
                      </tr>

                      <tr>
                        <td align="left" colSpan="9"></td>
                        <td align="center" colSpan="3">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}></p>
                        </td>
                        <td align="right" colSpan="1">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}></p>
                        </td>
                      </tr>

                      <tr>
                        <td align="left" colSpan="9"></td>
                        <td align="center" colSpan="3">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>NET TOTAL AMOUNT</p>
                        </td>
                        <td align="right" colSpan="1">
                          <p style={{ fontWeight: '500', fontSize: '10px' }}>239008</p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </td>
              </tr>

          <tr>
            <td align="right">
              <p style={{ fontWeight: '500', fontSize: '10px', maxWidth: '180px', width: '100%', textAlign: 'left', marginBottom: '3px' }}>
                Thanks You <br /><br /><br /> { "Vimla Enterprises"}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
    </>
  );
};

export default Format2;